var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpelers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40.006,
    viewBox: "0 0 40 40.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 40,
    height: 40.006,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M20,22.184h0a6.325,6.325,0,0,1-6.307-6.307V13.614a6.307,6.307,0,1,1,12.614,0v2.262A6.324,6.324,0,0,1,20,22.184",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M23.456,22.589a7.3,7.3,0,0,1-6.911,0A9.872,9.872,0,0,0,8.317,32.4v6.524a1.075,1.075,0,0,0,1.056,1.085H30.627a1.075,1.075,0,0,0,1.056-1.085V32.4a9.87,9.87,0,0,0-8.227-9.808",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M31.544,15.308a7.693,7.693,0,0,1-3.552.87h-.005a8.3,8.3,0,0,1-2.256,5.163,12.04,12.04,0,0,1,7.984,11.266v.118h5.2A1.088,1.088,0,0,0,40,31.64V25.116a9.953,9.953,0,0,0-8.456-9.808",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M27.993.006a6.328,6.328,0,0,0-6.278,5.721,8.346,8.346,0,0,1,6.3,8.077v1.079A6.325,6.325,0,0,0,34.3,8.577V6.313A6.325,6.325,0,0,0,27.993.006",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M6.286,32.607A12.039,12.039,0,0,1,14.27,21.341a8.309,8.309,0,0,1-2.256-5.162h-.005a7.709,7.709,0,0,1-3.552-.871A9.954,9.954,0,0,0,0,25.116V31.64a1.09,1.09,0,0,0,1.086,1.086h5.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M11.986,14.88V13.8a8.347,8.347,0,0,1,6.3-8.075A6.306,6.306,0,0,0,5.7,6.312V8.577a6.325,6.325,0,0,0,6.285,6.3",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpelers);
export default __webpack_public_path__ + "static/media/spelers.59ba427e8b10424700e6804d629db612.svg";
export { ForwardRef as ReactComponent };